import modalStyle from "../../modal.module.scss";

import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show_hover.svg";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";

import React, { useState, useEffect } from 'react';
import { Box, TextField, InputAdornment } from "@mui/material";

import { getDefaultTextFieldProp } from "../../../theme";

const Authentication = (props) => {
  const {
    username,
    setUsername,
    password,
    setPassword,
    setAuthenticateStatus
  } = props;

  // State
  const [isPassword, setIsPassword] = useState(false);

  // Method

  // Side effect
  useEffect(() => {
    setAuthenticateStatus(username.length > 0 && password.length > 0);
  }, [username, password, setAuthenticateStatus]);

  return (
    <>
      <Box display={"flex"} flexDirection="row" justifyContent="center" alignItems="center">
        <Box className={modalStyle['field-container']} style={{ marginBottom: '10px' }}>
          <Box style={{ marginRight: '30px' }}
          >
            Username
          </Box>
          <Box className={modalStyle['item']}>
            <Box style={{ width: '300px' }}>
              <TextField
                fullWidth
                placeholder=""
                type="text"
                value={username}
                autoComplete="new-password"
                onChange={(e) => setUsername(e.target.value)}
                sx={{ ...getDefaultTextFieldProp().sx }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box display={"flex"} flexDirection="row" justifyContent="center" alignItems="center">
        <Box className={modalStyle['field-container']}>
          <Box style={{ marginRight: '30px' }}>
            Password
          </Box>
          <Box className={modalStyle['item']}>
            <Box style={{ width: '300px' }}>
              <TextField
                fullWidth
                placeholder=""
                type={isPassword ? 'text' : 'password'}
                value={password}
                autoComplete="new-password"
                onChange={(e) => setPassword(e.target.value)}
                sx={{ ...getDefaultTextFieldProp().sx }}
                InputProps={{
                  endAdornment: isPassword ? (
                    <InputAdornment position="end">
                      <ShowIcon onClick={() => setIsPassword(!isPassword)} style={{ cursor: 'pointer' }} />
                    </InputAdornment>
                  ) : (
                    <InputAdornment position="end">
                      <HideIcon onClick={() => setIsPassword(!isPassword)} style={{ cursor: 'pointer' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Authentication;